
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-12-09/L1001004-bw_582eb06d55__20.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-12-09/L1001004-bw_582eb06d55__400.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-12-09/L1001004-bw_582eb06d55__800.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-12-09/L1001004-bw_582eb06d55__1600.jpg";


export default {
  id: "L1001004-bw",
  aspect: 1.5122440786832598,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        